module.exports = __webpack_public_path__ + "img/CycleManagerWeatherStation.25059c4a.png";